import CELL_DATA_TYPES from '../cell-types.config';
import { ACTIONS } from '../const.config';

// Quiz module configurations
export const LISTING_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    width: '10%',
    align: 'left',
    dataKey: 'title',
    sortable: true,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'passCriteria',
    label: 'Passing Criteria',
    width: '10%',
    align: 'right',
    dataKey: 'passCriteria',
    sortable: true,
    type: CELL_DATA_TYPES.PERCENTAGE,
  },
  {
    id: 'allowedAttempts',
    label: 'Attempts Allowed',
    width: '11%',
    align: 'right',
    dataKey: 'allowedAttempts',
    sortable: true,
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'startTime',
    label: 'Start Date',
    width: '15%',
    align: 'left',
    dataKey: 'startTime',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'endTime',
    label: 'End Date',
    width: '15%',
    align: 'left',
    dataKey: 'endTime',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'status',
    label: 'Status',
    width: '10%',
    align: 'center',
    dataKey: 'status',
    sortable: true,
    type: CELL_DATA_TYPES.SWITCH,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    width: '15%',
    align: 'left',
    dataKey: 'createdAt',
    sortable: true,
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_ACTIONS = [
  {
    action: ACTIONS.EDIT.value,
    label: ACTIONS.EDIT.label,
  },
  // {
  //   action: ACTIONS.TRANSLATE.value,
  //   label: ACTIONS.TRANSLATE.label,
  // },
  {
    action: ACTIONS.VIEW.value,
    label: ACTIONS.VIEW.label,
  },
  {
    action: ACTIONS.MANAGE_QUESTIONS.value,
    label: ACTIONS.MANAGE_QUESTIONS.label,
  },
  {
    action: ACTIONS.VIEW_QUIZ_RESULTS.value,
    label: ACTIONS.VIEW_QUIZ_RESULTS.label,
  },
  {
    action: ACTIONS.VIEW_DATA_CHANGE_LOGS.value,
    label: ACTIONS.VIEW_DATA_CHANGE_LOGS.label,
  },
  {
    action: ACTIONS.DELETE.value,
    label: ACTIONS.DELETE.label,
  },
];

export const VIEW_COLUMNS = [
  {
    id: 'title',
    label: 'Title',
    dataKey: 'title',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'description',
    label: 'Description',
    dataKey: 'description',
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'passCriteria',
    label: 'Passing Criteria',
    dataKey: 'passCriteria',
    type: CELL_DATA_TYPES.PERCENTAGE,
  },
  {
    id: 'allowedAttempts',
    label: 'Attempts Allowed',
    dataKey: 'allowedAttempts',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'showAnswersFromAttempt',
    label: 'Show Answers from Attempt',
    dataKey: 'showAnswersFromAttempt',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'startTime',
    label: 'Start Date',
    dataKey: 'startTime',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'endTime',
    label: 'End Date',
    dataKey: 'endTime',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
  {
    id: 'status',
    label: 'Status',
    dataKey: 'status',
    type: CELL_DATA_TYPES.STATUS,
  },
  {
    id: 'createdAt',
    label: 'Created At',
    dataKey: 'createdAt',
    type: CELL_DATA_TYPES.TIMESTAMP,
  },
];

export const LISTING_COLUMNS_SUBSCRIBER_RESULTS = [
  {
    id: 'questionText',
    label: 'Question',
    width: '30%',
    align: 'left',
    dataKey: 'questionText',
    sortable: false,
    type: CELL_DATA_TYPES.TEXT,
  },
  {
    id: 'optionText',
    label: 'Correct Answer',
    width: '30%',
    align: 'left',
    dataKey: 'optionText',
    sortable: false,
    type: CELL_DATA_TYPES.QUIZ_ANSWER,
  },
];

export const LIST_QUIZ_ATTEMPTS_RESULTS_ROWS = [
  {
    id: 'correctAnswers',
    title: 'No. of Correct Answers',
    dataKey: 'correctAnswers',
    type: CELL_DATA_TYPES.QUIZ_RESULT_MARKS_OUT_OF,
  },
  {
    id: 'skippedQuestions',
    title: 'No. of ̣Skipped Questions',
    dataKey: 'skippedQuestions',
    type: CELL_DATA_TYPES.QUIZ_RESULT_MARKS_OUT_OF,
  },
  {
    id: 'result',
    title: 'Result',
    dataKey: 'result',
    type: CELL_DATA_TYPES.QUIZ_RESULT_PERCENT_PF,
  },
  {
    id: 'timeTaken',
    title: 'Time Taken',
    dataKey: 'timeTaken',
    type: CELL_DATA_TYPES.DURATION,
  },
];
